module.exports = __webpack_public_path__ + "img/WIFI_AMENITY.228dd1c8.svg";